<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <CharacterForm @submit-requested="submitRequested"></CharacterForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import CharacterForm from './CharacterForm.vue'

  export default {
  components: { CharacterForm },
  methods: {
    ...mapActions('characters', ['postCharacter']),
    submitRequested (input) {
      this.postCharacter(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 